import { useIsAuthenticated } from "@azure/msal-react";
import { useCreaetUserInfo } from "lib/userInfo";
import React, { PropsWithChildren } from "react";
import useGetAccessPermissions from "./useGetAccessPermissions";
import useGetOpenTasksCount from "./useGetOpenTasksCount";

const StartupOperations: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  useCreaetUserInfo(isAuthenticated);
  useGetAccessPermissions();
  useGetOpenTasksCount();
  return <>{children}</>;
};
export default StartupOperations;
